export default "__VITE_ASSET__6baf9c39__"